var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDownCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.558015 1.44194L3.55802 4.44194C3.80209 4.68602 4.19782 4.68602 4.4419 4.44194L7.4419 1.44194C7.62065 1.26319 7.67412 0.99437 7.57738 0.760824C7.48064 0.527277 7.25275 0.375 6.99996 0.375H0.999957C0.747168 0.375 0.519271 0.527277 0.422533 0.760823C0.325794 0.99437 0.379267 1.26319 0.558015 1.44194Z",
    fill: "white",
    fillOpacity: 0.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownCalendar);
export default __webpack_public_path__ + "static/media/icon-arrow-down-calendar.691230a42a006f6b63ddf4d03ff7b02e.svg";
export { ForwardRef as ReactComponent };